import { withManagedForm } from "@/application/components/admin/connections/managedForm";

export function editConnectionForm({ allowlistedInputs = [] }) {
  const form = {
    initChild() {
      this.comparatorJsonArrays = this.comparatorJsonArrays.bind(this);
      this.filterMultiSelectChange = this.filterMultiSelectChange.bind(this);
    },
    filterMultiSelectChange(_parent, value, name) {
      const fieldName = this.nameToKey(name);
      this[fieldName] = JSON.stringify(value);
      this.watch(this.nameToKey(name))(this[fieldName]);
    },

    comparatorJsonArrays(initialValue, currentValue) {
      try {
        return this.destructiveArrayComparator(
          JSON.parse(initialValue),
          JSON.parse(currentValue),
        );
      } catch (e) {
        return false;
      }
    },
  };

  return withManagedForm(
    { formRef: "editConnectionForm", allowlistedInputs },
    form,
  );
}
